// @flow
import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Translate } from "@quantum/i18n";

import {
  getCamposMedida,
  getCamposSelecionados,
  selecionaCampos,
} from "../../../../state";

import { SelectInput } from "../../../comum";

const SelecaoCampos = () => {
  const dispatch = useDispatch();

  const campos = useSelector(getCamposMedida);

  const camposSelecionados = useSelector(getCamposSelecionados);

  const selecionarCampos = useCallback(
    campos => {
      dispatch(selecionaCampos(campos));
    },
    [dispatch]
  );

  const desmarcarTodosOsCampos = useCallback(() => {
    selecionarCampos([]);
  }, [selecionarCampos]);

  return (
    <div className="ConfiguracaoMedida">
      <div className="ConfiguracaoMedida__label">
        <Translate>Comum.Campos</Translate>
        {camposSelecionados.length >= 1 && (
          <span
            className="ConfiguracaoMedida__label--desmarcar"
            onClick={desmarcarTodosOsCampos}
          >
            <Translate>Comum.desmarcarTodos</Translate>
          </span>
        )}
      </div>
      <SelectInput
        onChange={selecionarCampos}
        value={camposSelecionados}
        options={campos}
        size={10}
        multiple
        campoId="id"
        campoDescricao="nome"
        selectedOptionsFirst
        sorting="alphabetical"
      />
    </div>
  );
};

export default SelecaoCampos;
